import "./CommunicationContentsSkeleton.scss";

type CommunicationContentsSkeletonProps = {
  cardsCount?: number;
};

const DEFAULT_CARDS_COUNT = 6;

export const CommunicationContentsSkeleton = ({
  cardsCount = DEFAULT_CARDS_COUNT,
}: CommunicationContentsSkeletonProps) => {
  return (
    <section className="communication-contents-skeleton">
      {/* Section title */}
      <div className="communication-contents-skeleton-title pulse" />

      {/* Cards grid */}
      <div className="communication-contents-skeleton-grid">
        {Array.from({ length: cardsCount }).map((_, index) => (
          <div className="communication-contents-skeleton-card" key={index}>
            {/* Image placeholder */}
            <div className="communication-contents-skeleton-image pulse" />

            {/* Card content */}
            <div className="communication-contents-skeleton-body">
              <div className="communication-contents-skeleton-line communication-contents-skeleton-line-sm pulse" />
              <div className="communication-contents-skeleton-line communication-contents-skeleton-line-md pulse" />

              {/* Tags */}
              <div className="communication-contents-skeleton-tags">
                <span className="communication-contents-skeleton-chip pulse" />
                <span className="communication-contents-skeleton-chip pulse" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
